export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_INBOX_DATA = 'SET_INBOX_DATA';
export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';
export const SET_EXPENSE_DATA = 'SET_EXPENSE_DATA';
export const SET_DOCUMENTS_DATA = 'SET_DOCUMENTS_DATA';
export const SET_SUMMARY_STATS = 'SET_SUMMARY_STATS';
export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING';
export const SET_DASHBOARD_ERROR = 'SET_DASHBOARD_ERROR';
